"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const TerraformActionNodeValidation_1 = require("../validations/TerraformActionNodeValidation");
const utils_1 = require("../helper/utils");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class TerraformActionNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.TerraformCloudAction };
    if (props.type !== types_1.NODE_TYPES.TerraformCloudAction)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        service: "",
        method: "",
        params: {}
      };
    return {
      ...nodeData
    };
  }
  serialize(uiData) {
    return {
      ...uiData
    };
  }
  validate() {
    return new TerraformActionNodeValidation_1.TerraformActionNodeValidation().validate(
      this
    );
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      let { service } = nodeData;
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: [this.getNodeName(), utils_1.wordify(service)].join("."),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources;
  }
  async getOutputKeys(params) {
    let nodeData = this.getNodeData();
    if (!nodeData || !nodeData.service || !nodeData.method) return [];
    let { service, method } = nodeData;
    let outputKeys = await fetchOutputKeys_1.fetchTerraformOutputKeys(
      service,
      method
    );
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.TerraformCloud;
  }
}
exports.TerraformActionNode = TerraformActionNode;
//# sourceMappingURL=TerraformActionNode.js.map
